export default __webpack_public_path__ + "static/media/GALERIA_construyendo-el-futuro.e9037755.jpg";